/**
 * 30 条死法/行为称号：结算时按死因 + 对局行为选取。
 * 称号为外观型收集物（跨日图鉴属后续阶段），本阶段在结算页展示。
 */
export interface TitleContext {
  cause: string;
  time: number;
  kills: number;
  level: number;
  evolutions: number;
  passiveCoverage: number;
  gold: number;
}

interface Rule {
  text: string;
  cond?: (c: TitleContext) => boolean;
}

const G: Rule[] = [
  { text: '再多打一下', cond: (c) => c.time < 60 },
  { text: '经验的奴隶', cond: (c) => c.kills >= 120 },
  { text: '刀口舔血', cond: (c) => c.level >= 10 },
  { text: '富贵险中求', cond: (c) => c.gold >= 40 },
  { text: '贪字得个死' },
];
const SU: Rule[] = [
  { text: '包围圈中心', cond: (c) => c.time < 90 },
  { text: '无路可走', cond: (c) => c.kills >= 80 },
  { text: '十面埋伏', cond: (c) => c.level >= 8 },
  { text: '人墙' },
];
const CH: Rule[] = [
  { text: '迎面撞上', cond: (c) => c.time < 45 },
  { text: '闪避不能', cond: (c) => c.kills >= 60 },
  { text: '冲锋鉴定为真', cond: (c) => c.level >= 7 },
  { text: '犬口脱险失败' },
];
const BO: Rule[] = [
  { text: '一声巨响', cond: (c) => c.time < 60 },
  { text: '原地升天', cond: (c) => c.kills >= 70 },
  { text: '引信观察员', cond: (c) => c.level >= 7 },
  { text: '蘑菇猎人（反讽）' },
];
const EL: Rule[] = [
  { text: '精英恐惧症', cond: (c) => c.time < 120 },
  { text: '词条受害者', cond: (c) => c.kills >= 100 },
  { text: '技不如人', cond: (c) => c.level >= 10 },
  { text: '精英猎手（反讽）' },
];
const BS: Rule[] = [
  { text: '差一点', cond: (c) => c.evolutions >= 1 },
  { text: '技能全吃', cond: (c) => c.kills >= 200 },
  { text: '团灭发动机', cond: (c) => c.level >= 12 },
  { text: 'Boss 观察员' },
];
const AT: Rule[] = [
  { text: '温水煮英雄', cond: (c) => c.time >= 180 },
  { text: '弹尽粮绝' },
];
const SH: Rule[] = [
  { text: '裸奔勇士', cond: (c) => c.time >= 120 },
  { text: '护盾是消耗品' },
];
const TO: Rule[] = [{ text: '时间不站在我这边' }];

const BY_CAUSE: Record<string, Rule[]> = {
  GREED: G, SURROUNDED: SU, CHARGED: CH, BOMBED: BO,
  ELITE_COUNTER: EL, BOSS_SKILL: BS, ATTRITION: AT,
  SHIELD_CHIP: SH, TIMEOUT: TO,
};

/** 选称号：同死因组内取首个满足行为条件的规则，兜底组内最后一条。 */
export function pickTitle(c: TitleContext): string {
  const rules = BY_CAUSE[c.cause] ?? AT;
  for (const r of rules) {
    if (!r.cond || r.cond(c)) return r.text;
  }
  return rules[rules.length - 1]!.text;
}

export const TITLE_COUNT = 30;
